import { gql } from "@apollo/client";

export const GET_KEYWORDS = gql`
  query GetKeywords($url: String!, $filter_type: String, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    keywords(url: $url, filter_type: $filter_type, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      url
      filter_type
      total_keywords
      keywords
    }
  }
`;
